import Head from 'react-helmet';
import type { State } from 'app/shared/types/State';

const PageHead = ({ address, canonicalURL }: { address: State['address']; canonicalURL: string }) => {
  const { street, city, state, zip, unit } = address;
  const addressStr = street + (unit && unit !== ' ' ? ', Unit ' + unit : '') + ', ' + city + ', ' + state + ' ' + zip;
  const title = `Price My Rental Results - ${addressStr} | Zillow Rental Manager`;
  const description = ` Zillow Price My Rental Results for ${addressStr} | Zillow Rental Manager`;
  const metas = [
    { name: 'description', content: description },
    { name: 'robots', content: 'noindex' },
  ];
  const link = [];
  if (canonicalURL) {
    link.push({
      rel: 'canonical',
      href: canonicalURL,
    });
  }

  return <Head title={title} meta={metas} link={link} />;
};

export default PageHead;
